import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import * as Progress from "react-native-progress";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";
import { Box, MainText, PressableOpacity } from "app/components/common";

const getColor = progress => {
  if (progress < 0.45) {
    return theme.colors["system.red.950"];
  }
  return theme.colors["brand.500"];
};

const styles = {
  main: {
    marginTop: theme.spacing.xs,
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
};

interface IProps {
  progress: number;
  style?: {};
  onPress?: () => void;
}

const CompleteProfile = ({
  progress,
  onPress = () => {},
  style = {},
}: IProps) => {
  const [width, setWidth] = useState(300);

  const findDimensions = ({ height, width }) => {
    setWidth(width);
  };

  const handleOnLayout = event => {
    findDimensions(event.nativeEvent.layout);
  };

  const percentProfileCompleted = (progress * 100).toFixed(0);

  return (
    <PressableOpacity
      isDisabled={!onPress}
      onPress={onPress}
      style={[styles.main, style]}
    >
      {progress < 1 && (
        <Box
          width="100%"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="flex-end"
          marginBottom="s"
        >
          <MainText color="neutral.600" variant="l3-medium">
            {i18n.t("complete-profil-for-a-better-experience")}
          </MainText>
          <MainText
            variant="l4-bold"
            color="brand.500"
          >{`${percentProfileCompleted}%`}</MainText>
        </Box>
      )}
      <Box
        width="100%"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        onLayout={handleOnLayout}
      >
        <Progress.Bar
          progress={progress}
          width={width}
          height={5}
          borderRadius={10}
          strokeCap={"round"}
          animated={true}
          useNativeDriver
          borderWidth={0}
          color={getColor(progress)}
          unfilledColor={theme.colors["neutral.100"]}
        />
      </Box>
    </PressableOpacity>
  );
};

export default CompleteProfile;
